import { memo } from "preact/compat";
import { useModal } from "../../shared/contexts";
import { Typography, Box, Image } from "../../shared/ui";
import { useUserStore } from "../../store/userStore";
import { BurgerMenu } from "../BurgerMenu";
import styles from "./Header.module.scss";

const GAME_TYPE = import.meta.env.VITE_GAME_TYPE || "twins";
const LOGO_SRC = GAME_TYPE === "pioneer" ? "logo.png" : "twins_logo.png";

export interface HeaderProps {
  headerRef?: any;
  isStickyActive?: boolean;
}

function HeaderComponent({ headerRef, isStickyActive = true }: HeaderProps) {
  const { profile } = useUserStore();
  const { openModal } = useModal();

  const handleLogoClick = () => {
    openModal("skins");
  };
  return (
    <Box
      as="header"
      domRef={headerRef}
      className={`${styles.header} ${!isStickyActive ? styles.headerStatic : ""}`}
      bg="dark"
      display="flex"
      justify="between"
      align="center"
    >
      <button className={styles.logo} onClick={handleLogoClick}>
        <div className={styles.logoIcon}>
          <Image src={LOGO_SRC} />
        </div>
      </button>

      <div className={styles.actions}>
        <div className={styles.balance}>
          <Typography variant="h2" color="green">
            {profile?.balance?.toFixed(2) ?? 0}
          </Typography>
          <Typography variant="h2" color="light-grey">
            {"USD"}
          </Typography>
        </div>
        <BurgerMenu />
      </div>
    </Box>
  );
}

export const Header = memo(HeaderComponent);
